module.exports = __webpack_public_path__ + "static/media/bancolombia-ico-reloj.def59d7f.svg";